/**
 * Sports for which AI scoresheet scanning is supported.
 *
 * - basketball: one paper scoresheet PER TEAM (players + points + fouls). A game
 *   needs two photos (home + away).
 * - pickleball: one round-robin scoresheet for the WHOLE DIVISION (all matchup
 *   scores across rounds). One photo fills every game in the division.
 *
 * Shared between apps/admin (entry-point gating) and apps/api (parse-request
 * validation) so the two never drift.
 */
export const SCORESHEET_SUPPORTED_SPORTS = ['basketball', 'pickleball'] as const;

export type ScoresheetSport = (typeof SCORESHEET_SUPPORTED_SPORTS)[number];

export function isScoresheetSupportedSport(
  sport: string | undefined | null,
): sport is ScoresheetSport {
  return !!sport && (SCORESHEET_SUPPORTED_SPORTS as readonly string[]).includes(sport);
}
